/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdminCompanyAddRemoveCouchRequestDto
 */
export interface AdminCompanyAddRemoveCouchRequestDto {
  /**
   *
   * @type {string}
   * @memberof AdminCompanyAddRemoveCouchRequestDto
   */
  adminId: string;
}

export function AdminCompanyAddRemoveCouchRequestDtoFromJSON(json: any): AdminCompanyAddRemoveCouchRequestDto {
  return AdminCompanyAddRemoveCouchRequestDtoFromJSONTyped(json, false);
}

export function AdminCompanyAddRemoveCouchRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminCompanyAddRemoveCouchRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    adminId: json["adminId"],
  };
}

export function AdminCompanyAddRemoveCouchRequestDtoToJSON(value?: AdminCompanyAddRemoveCouchRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    adminId: value.adminId,
  };
}
